module.exports = __webpack_public_path__ + "static/media/cancel.36729d8c.svg";